import styled from 'styled-components';

export const TopicCardStyled = styled.div`
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  padding: 22px 20px;

  @media (max-width: 720px) {
    padding: 22px 14px;
  }
`;

export const TopicHeading = styled.h1`
  font-size: clamp(18px, 2vw, 24px);
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const CardShortDetail = styled.p`
  font-size: clamp(13px, 2vw, 14px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 68%);
  padding-top: 12px;
`;

export const PostAndFollowers = styled.div`
  display: flex;
  align-items: center;
  font-size: clamp(12px, 2vw, 14px);
  font-weight: ${(props) => (props.topicListing ? '400' : '500')};
  color: hsl(0deg, 0%, 0%, 74%);
  opacity: ${(props) => (props.topicListing ? '0.9' : '1')};
  padding: ${(props) => props.padding};

  img {
    margin-right: 4px;
  }

  span {
    padding-right: 4px;
  }

  .hideMweb {
    @media (max-width: 720px) {
      display: none;
    }
  }

  .post,
  .follower {
    @media (max-width: 720px) {
      display: none;
    }
  }
`;

export const FollowButton = styled.button`
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background-color: #ef4e5e;
  border: 1px solid #ef4e5e;
  outline: none;
  height: 38px;
  line-height: 38px;
  text-align: center;
  width: 100%;
  max-width: 120px;
  border-radius: 2px;
  cursor: pointer;
  border-radius: 4px;

  @media (max-width: 720px) {
    cursor: default;
    max-width: 90px;
  }
`;
